import { Card, CardHeader } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import useGetAppConnectionsHistory from "../services/useGetAppConnectionsHistory";
import ConnectionsPeriodChart from "./ConnectionsPeriodChart";
import Context from "./context";
import PeriodsControl from "./PeriodsControl/PeriodsControl";
import useConnectionsPeriodsStore from "./store";

// ----------------------------------------------------------------------

export const ConnectionsPeriodCard = () => {
	const [state, actions] = useConnectionsPeriodsStore();

	const { setPeriod } = useGetAppConnectionsHistory({ actions });

	const { translate } = useLocales();

	return (
		<Card sx={{ pb: 2 }}>
			<CardHeader title={translate("overview.connections_by_period")} />
			<Context.Provider value={{ state, actions: { ...actions, setPeriod } }}>
				<ConnectionsPeriodChart />
				<PeriodsControl />
			</Context.Provider>
		</Card>
	);
};

export default ConnectionsPeriodCard;
